import { manufacturerLogoSlug } from './manufacturerLogo'

/** Curated smartphone tiles — always treated as quality logos. */
const CURATED_LOGO_MANUFACTURERS = new Set([
  'apple',
  'samsung',
  'google',
  'oneplus',
  'motorola',
  'sony',
  'xiaomi',
  'nokia',
  'honor',
  'asus',
  'huawei',
  'nothing',
])

/** Manufacturer slugs backed by Simple Icons (vector, not favicon/monogram). */
const QUALITY_LOGO_SLUGS = new Set([
  'alcatel',
  'blackberry',
  'blu',
  'cat',
  'doro',
  'emporia',
  'kyocera',
  'lg',
  'panasonic',
  'philips',
  'sharp',
  'sony-ericsson',
  'tcl',
  'zte',
])

/**
 * Popular feature-phone brands in the basic-phone sell flow (catalog volume order).
 * Only brands with curated PNG or Simple Icons logos — no favicon/monogram tiles.
 */
export const BASIC_PHONE_DISPLAY_BRANDS = [
  'Nokia',
  'Samsung',
  'Motorola',
  'BLU',
  'Alcatel',
  'LG',
  'ZTE',
  'Panasonic',
  'BlackBerry',
  'Philips',
  'Sharp',
  'Doro',
  'Emporia',
  'CAT',
  'Kyocera',
  'TCL',
  'Sony',
  'Sony Ericsson',
] as const

export type BasicPhoneDisplayBrand = (typeof BASIC_PHONE_DISPLAY_BRANDS)[number]

const DISPLAY_BRAND_SET = new Set<string>(BASIC_PHONE_DISPLAY_BRANDS)

export function isBasicPhoneDisplayBrand(manufacturer: string): boolean {
  return DISPLAY_BRAND_SET.has(manufacturer.trim())
}

/** Hidden from sell-form manufacturer pickers (poor logo tiles); catalog unchanged. */
const MANUFACTURER_PICKER_HIDDEN = new Set(['emporia', 'tcl'])

export function isManufacturerVisibleInPicker(manufacturer: string): boolean {
  return !MANUFACTURER_PICKER_HIDDEN.has(manufacturer.trim().toLowerCase())
}

/** True when we have a curated PNG or Simple Icons asset (not favicon/monogram). */
export function hasQualityManufacturerLogo(manufacturer: string): boolean {
  const key = manufacturer.trim().toLowerCase()
  if (CURATED_LOGO_MANUFACTURERS.has(key)) return true
  return QUALITY_LOGO_SLUGS.has(manufacturerLogoSlug(manufacturer))
}

export function isBasicPhoneSellManufacturer(manufacturer: string): boolean {
  return isBasicPhoneDisplayBrand(manufacturer) && hasQualityManufacturerLogo(manufacturer)
}
